// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".component-ui__scroll-to-to-btn{z-index:10;position:fixed!important;bottom:100px;right:20px;border-radius:50%;font-weight:400;display:flex;align-items:center;justify-content:center;background:var(--v-grey-light-base);border:1px solid #e8ecf4;color:var(--v-grey-base);width:40px;height:40px}.component-ui__scroll-to-to-btn i{margin-left:0!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
